import { useTheme } from '@fluentui/react';
import React from 'react';
import { Column } from './Column';
import { Row } from './Row';
export const Title = (props) => {
    var _a, _b;
    const theme = useTheme();
    const TEXT_STYLE = Object.assign(Object.assign({ marginTop: '20px' }, (_a = props.styles) === null || _a === void 0 ? void 0 : _a.text), { color: theme.palette.black, fontSize: theme.fonts.mediumPlus.fontSize });
    return React.createElement(Row, null,
        React.createElement(Column, { lg: 12, md: 12, sm: 12, style: TEXT_STYLE },
            React.createElement("h1", { className: props.className, style: (_b = props.styles) === null || _b === void 0 ? void 0 : _b.text }, props.text)));
};
